export const getSizeList = (items) => {
  const BASE_CALC = 25

  if (items && items.length > 0) {
    return Math.round(items.length / 13) * BASE_CALC
  }

  return BASE_CALC
}
